<prlw-table-volume-progress-bar-ui
  *ngIf="current"
  [progressData]="progressData"
></prlw-table-volume-progress-bar-ui>
